/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/gateways';
import '../payments/common';
import '../common/countries';
import '../common/instrument';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "binfo": {
        "nested": {
          "api": {
            "nested": {
              "CardType": {
                "values": {
                  "DEFAULT_CARD_TYPE_DO_NOT_USE": 1,
                  "DEBIT": 2,
                  "CREDIT": 3
                }
              },
              "DebitType": {
                "values": {
                  "DEFAULT_DEBIT_TYPE_DO_NOT_USE": 1,
                  "REGULATED": 2,
                  "UNREGULATED": 3,
                  "REGULATED_FRAUD": 4
                }
              },
              "PrepaidStatus": {
                "values": {
                  "DEFAULT_CATEGORY_DO_NOT_USE": 1,
                  "NOT_PREPAID": 2,
                  "PREPAID": 3
                }
              },
              "CardProduct": {
                "values": {
                  "DEFAULT_CARD_PRODUCT_DO_NOT_USE": 1,
                  "INTERNATIONAL_MAESTRO": 2,
                  "DINERS_CLUB": 3,
                  "DISCOVER": 4,
                  "INTERAC": 5,
                  "JCB": 6,
                  "MASTERCARD": 7,
                  "PIN_ONLY": 8,
                  "VISA": 9,
                  "AMEX": 10,
                  "GE_CAPITAL": 11,
                  "PRIVATE_LABEL": 12,
                  "SQUARE_GIFT_CARD_V2": 13,
                  "UNION_PAY": 14,
                  "SQUARE_CAPITAL_CARD": 15,
                  "EFTPOS": 16,
                  "FELICA_ID": 17,
                  "FELICA_TRANSPORTATION": 18,
                  "FELICA_QP": 19,
                  "ALIPAY": 20,
                  "CASH_APP": 21,
                  "EBT": 22,
                  "PAYPAY": 23,
                  "AFTERPAY": 24,
                  "SQUARE_ACCOUNT_BALANCE": 25,
                  "PAYPAL": 26,
                  "AU_PAY": 27,
                  "WECHAT_PAY": 28,
                  "D_BARAI": 29,
                  "MERPAY": 30,
                  "RAKUTEN_PAY": 31
                }
              },
              "CardProductCategory": {
                "values": {
                  "DEFAULT_CARD_PRODUCT_CATEGORY_DO_NOT_USE": 1,
                  "CONSUMER": 2,
                  "BUSINESS": 3,
                  "COMMERCIAL": 4,
                  "GOVERNMENT": 5
                }
              },
              "PinCategory": {
                "values": {
                  "DEFAULT_PIN_CATEGORY_DO_NOT_USE": 1,
                  "NO_PIN": 2,
                  "PIN_CAPABLE": 3,
                  "PIN_DEBIT_ONLY_WITH_EBT": 4,
                  "PIN_DEBIT_ONLY_WITHOUT_EBT": 5
                }
              },
              "DebitNetwork": {
                "values": {
                  "DEFAULT_DEBIT_NETWORK_DO_NOT_USE": 1,
                  "ACCEL": 2,
                  "ACCEL_FISERV": 3,
                  "AFFN": 4,
                  "AFFN_DIRECT": 5,
                  "AFFN_FIDELITY": 6,
                  "AFFN_FISERV": 7,
                  "ALASKA_OPTION": 8,
                  "ALASKA_OPTION_FISERV": 9,
                  "ATH_DIRECT": 10,
                  "ATH_SCOTIA_BANK": 11,
                  "BASE_24": 12,
                  "CNB_ENID": 13,
                  "CU24_DIRECT": 14,
                  "CU24_FIDELITY": 15,
                  "CU24_FISERV": 16,
                  "CU_24": 17,
                  "EBT_ACS": 18,
                  "EBT_EFUNDS": 19,
                  "EBT_FISERV": 20,
                  "EBT_JPCHASE": 21,
                  "EBT_NORTHRUP_GRUMMAN": 22,
                  "EBT_TEAM_OF_TEXAS": 23,
                  "EVERLINK": 24,
                  "EVERLINK_INTERAC_ICU": 25,
                  "EXXON": 26,
                  "FISERV": 27,
                  "INSTANT_TELLER": 28,
                  "INTERAC_EVERLINK": 29,
                  "INTERLINK": 30,
                  "INTERLINK_FISERV": 31,
                  "JEANIE": 32,
                  "JEANIE_DIRECT": 33,
                  "JEANIE_STAR_WEST": 34,
                  "MAESTRO": 35,
                  "MAESTRO_DIRECT": 36,
                  "MAESTRO_FISERV": 37,
                  "MAESTRO_STAR_WEST": 38,
                  "MPACT": 39,
                  "NYCE": 40,
                  "NYCE_FISERV": 41,
                  "PAVD": 42,
                  "PULSE": 43,
                  "PULSE_FISERV": 44,
                  "PULSE_TYME": 45,
                  "QUEST_EBT": 46,
                  "SHAZAM": 47,
                  "STAR_EAST": 48,
                  "STAR_EAST_FISERV": 49,
                  "STAR_NE": 50,
                  "STAR_NE_FISERV": 51,
                  "STAR_NORTHEAST": 52,
                  "STAR_WEST": 53,
                  "STAR_WEST_ALASKA_OPTION": 54,
                  "STAR_WEST_FISERV": 55,
                  "SVS": 56,
                  "TEMPO": 57,
                  "TX": 58,
                  "TYME": 59,
                  "NETS": 60,
                  "CHINA_UNION_PAY": 61,
                  "STAR_ACCESS": 62
                }
              },
              "HsaFsaStatus": {
                "values": {
                  "DEFAULT_DO_NOT_USE": 1,
                  "NOT_HSA_FSA": 2,
                  "HSA": 3,
                  "FSA": 4,
                  "HSA_AND_FSA": 5
                }
              },
              "FastFunds": {
                "values": {
                  "DEFAULT_FAST_FUNDS_DO_NOT_USE": 1,
                  "NONE": 2,
                  "DOMESTIC": 3,
                  "CROSS_BORDER": 4,
                  "DOMESTIC_AND_CROSS_BORDER": 5
                }
              },
              "SquareIssuedCard": {
                "values": {
                  "UNKNOWN_OR_NOT_SQUARE_ISSUED": 1,
                  "CASH_CARD": 2,
                  "SQUARE_CARD": 3,
                  "AFTERPAY_CARD": 4
                }
              },
              "PinlessDebitStatus": {
                "values": {
                  "DEFAULT_PINLESS_DEBIT_STATUS_DO_NOT_USE": 1,
                  "PINLESS_DEBIT_ALLOWED": 2
                }
              },
              "ECommerceStatus": {
                "values": {
                  "DEFAULT_ECOMMERCE_STATUS_DO_NOT_USE": 1,
                  "ECOMMERCE_ALLOWED": 2
                }
              },
              "PremierStatus": {
                "values": {
                  "DEFAULT_PREMIER_STATUS_DO_NOT_USE": 1,
                  "PREMIER_ISSUER": 2
                }
              },
              "BinBlockReason": {
                "values": {
                  "DEFAULT_REASON_DO_NOT_USE": 1,
                  "SANCTION": 2
                }
              },
              "SourceTree": {
                "values": {
                  "DEFAULT_SOURCE_TREE_DO_NOT_USE": 1,
                  "CONTROL": 2,
                  "TREATMENT": 3
                }
              },
              "OctProperties": {
                "fields": {
                  "canReceiveOctFromUsaP2p": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "canReceiveOctFromUsaNonP2p": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "canReceiveOctFromNonUsaP2p": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "canReceiveOctFromNonUsaNonP2p": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "fastFunds": {
                    "type": "squareup.binfo.api.FastFunds",
                    "id": 5,
                    "rule": "optional"
                  },
                  "supportOctMoneyTransferDomestic": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "supportOctMoneyTransferCrossBorder": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "supportOctNonMoneyTransferDomestic": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "supportOctNonMoneyTransferCrossBorder": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "FundsTransferProperties": {
                "fields": {
                  "canReceiveFundsTransferCredit": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "canReceiveFundsTransferDebit": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fastFunds": {
                    "type": "squareup.binfo.api.FastFunds",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ChaseMethodOfPayment": {
                "values": {
                  "DEFAULT_CHASE_METHOD_OF_PAYMENT_DO_NOT_USE": 1,
                  "CR_CHASE_NET_SIGNATURE_DEBIT_OR_PREPAID": 2,
                  "CZ_CHASE_NET_CREDIT": 3,
                  "CX_CHASE_NET_PIN_DEBIT": 4
                }
              },
              "SupportedRoute": {
                "fields": {
                  "gatewayName": {
                    "type": "squareup.common.gateways.GatewayName",
                    "id": 1,
                    "rule": "optional"
                  },
                  "messageType": {
                    "type": "squareup.payments.common.MessageType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "fundsTransferProperties": {
                    "type": "squareup.binfo.api.FundsTransferProperties",
                    "id": 5,
                    "rule": "optional"
                  },
                  "pinlessDebitStatus": {
                    "type": "squareup.binfo.api.PinlessDebitStatus",
                    "id": 6,
                    "rule": "optional"
                  },
                  "ecommerceStatus": {
                    "type": "squareup.binfo.api.ECommerceStatus",
                    "id": 7,
                    "rule": "optional"
                  },
                  "premierStatus": {
                    "type": "squareup.binfo.api.PremierStatus",
                    "id": 8,
                    "rule": "optional"
                  },
                  "destination": {
                    "type": "squareup.binfo.api.SupportedRoute.Destination",
                    "id": 2,
                    "options": {
                      "default": "DEFAULT_DESTINATION"
                    }
                  },
                  "repeatedDebitNetwork": {
                    "type": "squareup.binfo.api.SupportedRoute.RepeatedDebitNetwork",
                    "id": 4
                  }
                },
                "nested": {
                  "Destination": {
                    "values": {
                      "DEFAULT_DO_NOT_USE": 0,
                      "DEFAULT_DESTINATION": 1,
                      "OTHER": 2,
                      "CHASENET": 3
                    }
                  },
                  "RepeatedDebitNetwork": {
                    "fields": {
                      "debitNetworks": {
                        "type": "squareup.binfo.api.DebitNetwork",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "destination_or_debit_networks": {
                    "oneof": ["destination", "repeatedDebitNetwork"]
                  }
                }
              },
              "MpeBsaType": {
                "values": {
                  "DEFAULT_MPE_BSA_TYPE_DO_NOT_USE": 0,
                  "INTERREGIONAL": 1,
                  "INTRAREGIONAL": 2,
                  "INTERCOUNTRY": 3,
                  "INTRACOUNTRY": 4,
                  "B2B_C2C_ARRANGEMENT": 8
                }
              },
              "MpeBsa": {
                "fields": {
                  "type": {
                    "type": "squareup.binfo.api.MpeBsaType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "id": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "selectionEnforcementIndicator": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MpeBinBsas": {
                "fields": {
                  "cardProgramId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "issuerCardProgramPriority": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "bsa": {
                    "type": "squareup.binfo.api.MpeBsa",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "MpeBinProperties": {
                "fields": {
                  "mipCardProgramId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "mipGcmsProductId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "mipPriority": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "moneySendIndicator": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "fasterFundsIndicator": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "region": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "country": {
                    "type": "squareup.common.countries.Country",
                    "id": 7,
                    "rule": "optional"
                  },
                  "almParticipationIndicator": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "contactlessEnabledIndicator": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "nonReloadablePrepaidSwitch": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "anonymousPrepaidIndicator": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "regulatedRateTypeIndicator": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "productTypeId": {
                    "type": "int32",
                    "id": 14,
                    "rule": "optional"
                  },
                  "bsas": {
                    "type": "squareup.binfo.api.MpeBinBsas",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "MpeBinIssuer": {
                "fields": {
                  "cardProgramId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "issuerCardProgramPriority": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "gcmsProductId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "moneySendIndicator": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "fasterFundsIndicator": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "region": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "country": {
                    "type": "squareup.common.countries.Country",
                    "id": 7,
                    "rule": "optional"
                  },
                  "almParticipationIndicator": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "contactlessEnabledIndicator": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "nonReloadablePrepaidSwitch": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "anonymousPrepaidIndicator": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "regulatedRateTypeIndicator": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "productTypeId": {
                    "type": "int32",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "MpeBsaV2": {
                "fields": {
                  "typeId": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "selectionEnforcementIndicator": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "MpeBinBsasV2": {
                "fields": {
                  "cardProgramId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "issuerCardProgramPriority": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "bsa": {
                    "type": "squareup.binfo.api.MpeBinBsasV2",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "bsaV2": {
                    "type": "squareup.binfo.api.MpeBsaV2",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "MultiMpeBinProperties": {
                "fields": {
                  "binIssuer": {
                    "type": "squareup.binfo.api.MpeBinIssuer",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "bsas": {
                    "type": "squareup.binfo.api.MpeBinBsasV2",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "DiscoverBinProperties": {
                "fields": {
                  "discoverCardProduct": {
                    "type": "squareup.binfo.api.DiscoverCardProduct",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DiscoverCardProduct": {
                "values": {
                  "CONSUMER_CREDIT_REWARDS": 1,
                  "COMMERCIAL_CREDIT": 2,
                  "CONSUMER_DEBIT": 3,
                  "COMMERCIAL_DEBIT": 4,
                  "PREPAID_NON_RELOADABLE": 5,
                  "PREPAID_RELOADABLE": 6,
                  "CONSUMER_CREDIT_PREMIUM": 7,
                  "CONSUMER_CREDIT_CORE": 8,
                  "PRIVATE_LABEL_CREDIT_CARD": 9,
                  "COMMERCIAL_CREDIT_EXECUTIVE_BUSINESS": 10,
                  "CONSUMER_CREDIT_PREMIUM_PLUS": 11,
                  "COMMERCIAL_PREPAID_NON_RELOADABLE": 12,
                  "COMMERCIAL_B2B_1_PREPAID_NON_RELOADABLE": 13,
                  "COMMERCIAL_B2B_2_CREDIT": 14
                }
              },
              "VisaBinProperties": {
                "fields": {
                  "productId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accountFundingSource": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "regionCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "issuerBin": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "alm": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "commercialLevel2": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "commercialLevel3": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "regulatedBin": {
                    "type": "squareup.binfo.api.DebitType",
                    "id": 8,
                    "rule": "optional"
                  },
                  "sharedBin": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "multiAccountAccess": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "vau": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "BinProperties": {
                "fields": {
                  "issuerName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "country": {
                    "type": "squareup.common.countries.Country",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardType": {
                    "type": "squareup.binfo.api.CardType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cardProduct": {
                    "type": "squareup.binfo.api.CardProduct",
                    "id": 5,
                    "rule": "optional"
                  },
                  "pinCategory": {
                    "type": "squareup.binfo.api.PinCategory",
                    "id": 6,
                    "rule": "optional"
                  },
                  "ebtCapable": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cardSubcategory": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "supportedDebitNetwork": {
                    "type": "squareup.binfo.api.DebitNetwork",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "hsaFsaStatus": {
                    "type": "squareup.binfo.api.HsaFsaStatus",
                    "id": 10,
                    "rule": "optional"
                  },
                  "prepaidStatus": {
                    "type": "squareup.binfo.api.PrepaidStatus",
                    "id": 11,
                    "rule": "optional"
                  },
                  "octProperties": {
                    "type": "squareup.binfo.api.OctProperties",
                    "id": 12,
                    "rule": "optional"
                  },
                  "supportedRoute": {
                    "type": "squareup.binfo.api.SupportedRoute",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "fundsTransferProperties": {
                    "type": "squareup.binfo.api.FundsTransferProperties",
                    "id": 14,
                    "rule": "optional"
                  },
                  "chaseMethodOfPayment": {
                    "type": "squareup.binfo.api.ChaseMethodOfPayment",
                    "id": 15,
                    "rule": "optional"
                  },
                  "proposed": {
                    "type": "squareup.binfo.api.BinProperties",
                    "id": 16,
                    "rule": "optional"
                  },
                  "fullPanGuessedInstrumentType": {
                    "type": "squareup.common.instrument.InstrumentType",
                    "id": 17,
                    "rule": "optional"
                  },
                  "debitType": {
                    "type": "squareup.binfo.api.DebitType",
                    "id": 18,
                    "rule": "optional"
                  },
                  "l3Eligible": {
                    "type": "bool",
                    "id": 19,
                    "rule": "optional"
                  },
                  "binPropertySource": {
                    "type": "squareup.binfo.api.BinProperties.BinPropertySource",
                    "id": 20,
                    "rule": "repeated"
                  },
                  "squareIssuedCard": {
                    "type": "squareup.binfo.api.SquareIssuedCard",
                    "id": 21,
                    "rule": "optional"
                  },
                  "normalizedIssuerName": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "reloadablePrepaid": {
                    "type": "bool",
                    "id": 23,
                    "rule": "optional"
                  },
                  "mpeBinProperties": {
                    "type": "squareup.binfo.api.MpeBinProperties",
                    "id": 24,
                    "rule": "optional"
                  },
                  "multiMpeBinProperties": {
                    "type": "squareup.binfo.api.MultiMpeBinProperties",
                    "id": 25,
                    "rule": "optional"
                  },
                  "binBlockedReason": {
                    "type": "squareup.binfo.api.BinBlockReason",
                    "id": 26,
                    "rule": "optional"
                  },
                  "sourceTree": {
                    "type": "squareup.binfo.api.SourceTree",
                    "id": 27,
                    "rule": "optional"
                  },
                  "tokenBin": {
                    "type": "bool",
                    "id": 28,
                    "rule": "optional"
                  },
                  "discoverBinProperties": {
                    "type": "squareup.binfo.api.DiscoverBinProperties",
                    "id": 29,
                    "rule": "optional"
                  },
                  "binLength": {
                    "type": "uint32",
                    "id": 30,
                    "rule": "optional"
                  },
                  "cardProductCategory": {
                    "type": "squareup.binfo.api.CardProductCategory",
                    "id": 31,
                    "rule": "optional"
                  },
                  "visaBinProperties": {
                    "type": "squareup.binfo.api.VisaBinProperties",
                    "id": 32,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BinPropertySource": {
                    "fields": {
                      "fieldNumber": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sourceNumber": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.CardType && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.DebitType && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.PrepaidStatus && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.CardProduct && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.CardProductCategory && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.PinCategory && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.DebitNetwork && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.HsaFsaStatus && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.FastFunds && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.SquareIssuedCard && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.PinlessDebitStatus && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.ECommerceStatus && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.PremierStatus && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.BinBlockReason && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.SourceTree && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.OctProperties && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.FundsTransferProperties && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.ChaseMethodOfPayment && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.SupportedRoute && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.SupportedRoute?.nested?.Destination && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.SupportedRoute?.nested?.RepeatedDebitNetwork && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.MpeBsaType && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.MpeBsa && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.MpeBinBsas && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.MpeBinProperties && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.MpeBinIssuer && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.MpeBsaV2 && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.MpeBinBsasV2 && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.MultiMpeBinProperties && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.DiscoverBinProperties && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.DiscoverCardProduct && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.VisaBinProperties && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.BinProperties && !$root.nested?.squareup?.nested?.binfo?.nested?.api?.nested?.BinProperties?.nested?.BinPropertySource) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CardType @ squareup/binfo/api.proto at 96:1
 */
export const CardType = $root.lookupEnum('squareup.binfo.api.CardType').values;
/**
 * SOURCE DebitType @ squareup/binfo/api.proto at 103:1
 */
export const DebitType = $root.lookupEnum('squareup.binfo.api.DebitType').values;
/**
 * SOURCE PrepaidStatus @ squareup/binfo/api.proto at 111:1
 */
export const PrepaidStatus = $root.lookupEnum('squareup.binfo.api.PrepaidStatus').values;
/**
 * SOURCE CardProduct @ squareup/binfo/api.proto at 118:1
 */
export const CardProduct = $root.lookupEnum('squareup.binfo.api.CardProduct').values;
/**
 * SOURCE CardProductCategory @ squareup/binfo/api.proto at 167:1
 */
export const CardProductCategory = $root.lookupEnum('squareup.binfo.api.CardProductCategory').values;
/**
 * SOURCE PinCategory @ squareup/binfo/api.proto at 176:1
 */
export const PinCategory = $root.lookupEnum('squareup.binfo.api.PinCategory').values;
/**
 * SOURCE DebitNetwork @ squareup/binfo/api.proto at 185:1
 */
export const DebitNetwork = $root.lookupEnum('squareup.binfo.api.DebitNetwork').values;
/**
 * SOURCE HsaFsaStatus @ squareup/binfo/api.proto at 251:1
 */
export const HsaFsaStatus = $root.lookupEnum('squareup.binfo.api.HsaFsaStatus').values;
/**
 * SOURCE FastFunds @ squareup/binfo/api.proto at 260:1
 */
export const FastFunds = $root.lookupEnum('squareup.binfo.api.FastFunds').values;
/**
 * SOURCE SquareIssuedCard @ squareup/binfo/api.proto at 269:1
 */
export const SquareIssuedCard = $root.lookupEnum('squareup.binfo.api.SquareIssuedCard').values;
/**
 * SOURCE PinlessDebitStatus @ squareup/binfo/api.proto at 277:1
 */
export const PinlessDebitStatus = $root.lookupEnum('squareup.binfo.api.PinlessDebitStatus').values;
/**
 * SOURCE ECommerceStatus @ squareup/binfo/api.proto at 283:1
 */
export const ECommerceStatus = $root.lookupEnum('squareup.binfo.api.ECommerceStatus').values;
/**
 * SOURCE PremierStatus @ squareup/binfo/api.proto at 289:1
 */
export const PremierStatus = $root.lookupEnum('squareup.binfo.api.PremierStatus').values;
/**
 * SOURCE BinBlockReason @ squareup/binfo/api.proto at 295:1
 */
export const BinBlockReason = $root.lookupEnum('squareup.binfo.api.BinBlockReason').values;
/**
 * SOURCE SourceTree @ squareup/binfo/api.proto at 301:1
 */
export const SourceTree = $root.lookupEnum('squareup.binfo.api.SourceTree').values;
/**
 * SOURCE OctProperties @ squareup/binfo/api.proto at 308:1
 */
export const OctProperties = $root.lookupType('squareup.binfo.api.OctProperties');
fixType(OctProperties);
Builder.createAndAttachToType(OctProperties);
/**
 * Information about how this BIN and network combination support funds transfer payments, such as
 * as pushes to a card.
 *
 * SOURCE FundsTransferProperties @ squareup/binfo/api.proto at 322:1
 */
export const FundsTransferProperties = $root.lookupType('squareup.binfo.api.FundsTransferProperties');
fixType(FundsTransferProperties);
Builder.createAndAttachToType(FundsTransferProperties);
/**
 * SOURCE ChaseMethodOfPayment @ squareup/binfo/api.proto at 333:1
 */
export const ChaseMethodOfPayment = $root.lookupEnum('squareup.binfo.api.ChaseMethodOfPayment').values;
/**
 * SupportedRoute describes a more granular addressable destination for a transaction.
 * For most payments, this isn't important and we can rely just on the gateway, but for
 * debit networks with some complex routing, this can have large cost implications.
 *
 * Example NYCE via STAR:
 * gateway_name = stardebit_payment_service
 * destination = NYCE
 *
 * SOURCE SupportedRoute @ squareup/binfo/api.proto at 348:1
 */
export const SupportedRoute = $root.lookupType('squareup.binfo.api.SupportedRoute');
fixType(SupportedRoute, {
  gatewayName: {
    required: true
  }
});
Builder.createAndAttachToType(SupportedRoute);
/**
 * SOURCE Destination @ squareup/binfo/api.proto at 349:3
 */
SupportedRoute.Destination = $root.lookupEnum('squareup.binfo.api.SupportedRoute.Destination').values;
/**
 * Some routes may only support certain debit networks, and so we need to track this information
 * in order to route appropriately. For example, perhaps bin 123456 supports networks N1 and N2, but
 * gateway X can only process N1. We need to make sure not to send N2 transactions to gateway X.
 *
 * This will often be empty, implying that the destination is enough information to route. Only
 * gateways that require this info fill this in. There should only ever be one of debit_networks
 * or destination present, but the oneof keyword does not work with repeated.
 *
 * SOURCE RepeatedDebitNetwork @ squareup/binfo/api.proto at 381:3
 */
SupportedRoute.RepeatedDebitNetwork = $root.lookupType('squareup.binfo.api.SupportedRoute.RepeatedDebitNetwork');
fixType(SupportedRoute.RepeatedDebitNetwork);
Builder.createAndAttachToType(SupportedRoute.RepeatedDebitNetwork);
/**
 * MPE Bin Properties
 * MPE Business Service Type
 * Enum values match the values defined by MC in "Global Clearing Management System Reference
 * Manual", 15 October 2019, https://drive.google.com/file/d/1pr9wiCScQH29Q93asNdOSR8zcb7dWUgD
 * Details in https://docs.google.com/document/d/1aqFe6jBj-JeInDlIEWNL79UueGBLQgaBGC52VdhcUn0
 *
 * SOURCE MpeBsaType @ squareup/binfo/api.proto at 416:1
 */
export const MpeBsaType = $root.lookupEnum('squareup.binfo.api.MpeBsaType').values;
/**
 * SOURCE MpeBsa @ squareup/binfo/api.proto at 426:1
 */
export const MpeBsa = $root.lookupType('squareup.binfo.api.MpeBsa');
fixType(MpeBsa);
Builder.createAndAttachToType(MpeBsa);
/**
 * BIN range BSAs from IP0090T1
 * we only store card program and priority so we can select just the BSAs from the
 * highest priority card program id within IP0090T1
 *
 * SOURCE MpeBinBsas @ squareup/binfo/api.proto at 435:1
 */
export const MpeBinBsas = $root.lookupType('squareup.binfo.api.MpeBinBsas');
fixType(MpeBinBsas);
Builder.createAndAttachToType(MpeBinBsas);
/**
 * deprecated in favor of MultiMpeBinProperties
 *
 * SOURCE MpeBinProperties @ squareup/binfo/api.proto at 442:1
 */
export const MpeBinProperties = $root.lookupType('squareup.binfo.api.MpeBinProperties');
fixType(MpeBinProperties);
Builder.createAndAttachToType(MpeBinProperties);
/**
 * Properties from IP0040T1
 *
 * SOURCE MpeBinIssuer @ squareup/binfo/api.proto at 463:1
 */
export const MpeBinIssuer = $root.lookupType('squareup.binfo.api.MpeBinIssuer');
fixType(MpeBinIssuer);
Builder.createAndAttachToType(MpeBinIssuer);
/**
 * SOURCE MpeBsaV2 @ squareup/binfo/api.proto at 479:1
 */
export const MpeBsaV2 = $root.lookupType('squareup.binfo.api.MpeBsaV2');
fixType(MpeBsaV2);
Builder.createAndAttachToType(MpeBsaV2);
/**
 * BIN range BSAs from IP0090T1
 *
 * SOURCE MpeBinBsasV2 @ squareup/binfo/api.proto at 486:1
 */
export const MpeBinBsasV2 = $root.lookupType('squareup.binfo.api.MpeBinBsasV2');
fixType(MpeBinBsasV2);
Builder.createAndAttachToType(MpeBinBsasV2);
/**
 * MPE Bin Properties proto with multiple records for each BIN range
 * consumers should use issuer_card_program_priority field to determine the highest
 * priority (lowest integer value) among records applicable for their use case
 *
 * SOURCE MultiMpeBinProperties @ squareup/binfo/api.proto at 500:1
 */
export const MultiMpeBinProperties = $root.lookupType('squareup.binfo.api.MultiMpeBinProperties');
fixType(MultiMpeBinProperties);
Builder.createAndAttachToType(MultiMpeBinProperties);
/**
 * Discover Properties for choosing a PTA (Discover's term for Interchange Fee Code)
 *
 * SOURCE DiscoverBinProperties @ squareup/binfo/api.proto at 506:1
 */
export const DiscoverBinProperties = $root.lookupType('squareup.binfo.api.DiscoverBinProperties');
fixType(DiscoverBinProperties);
Builder.createAndAttachToType(DiscoverBinProperties);
/**
 * SOURCE DiscoverCardProduct @ squareup/binfo/api.proto at 510:1
 */
export const DiscoverCardProduct = $root.lookupEnum('squareup.binfo.api.DiscoverCardProduct').values;
/**
 * SOURCE VisaBinProperties @ squareup/binfo/api.proto at 527:1
 */
export const VisaBinProperties = $root.lookupType('squareup.binfo.api.VisaBinProperties');
fixType(VisaBinProperties);
Builder.createAndAttachToType(VisaBinProperties);
/**
 * Keep this in sync with binfo.model.BinProperties.
 *
 * SOURCE BinProperties @ squareup/binfo/api.proto at 552:1
 */
export const BinProperties = $root.lookupType('squareup.binfo.api.BinProperties');
fixType(BinProperties);
Builder.createAndAttachToType(BinProperties);
/**
 * Indicates which source a given bin property was pulled from. For instance, if the highest
 * priority source for issuer_name was determined to OVERRIDE, the bin_property_source list would
 * then contain an instance of the BinPropertySource with values (2,3) indicating that bin property
 * 2 was derived from source 3 (as listed by their ordinal values).
 *
 * SOURCE BinPropertySource @ squareup/binfo/api.proto at 594:3
 */
BinProperties.BinPropertySource = $root.lookupType('squareup.binfo.api.BinProperties.BinPropertySource');
fixType(BinProperties.BinPropertySource);
Builder.createAndAttachToType(BinProperties.BinPropertySource);